<div class="root-body"
     data-testid="report-disbursements"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <p-table #xpresReportDisbursementssersGrid
                 [columns]="cols"
                 [value]="xpressReportDisbursements"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 scrollHeight="calc(95vh - 180px)"
                 [tableStyle]="{'min-width': '50rem'}">
            <ng-template pTemplate="caption">
                <div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="search-input"
                               [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                               placeholder="Search here..." />
                    </span>
                    <div class="flex flex row title-float-right">
                        <div class="ml-3 mt-2 mr-2">
                            <column-selector #columnSelector
                                 [defaultColumns]="defaultCols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn>
                        {{col.header}}
                        <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-xpressReportDisbursement>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="xpressReportDisbursement"></p-tableCheckbox>
                    </td>
                    <td *ngFor="let col of cols" class="ui-resizable-column" [style.width]="col.width">
                    </td>
                    <td>
                        <span class="action-icon-svg">
                            <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="xpressReportDisbursements.length > 0" style="padding-left: 10px">
                    Displaying {{first + 1}} - {{first + xpressReportDisbursements.length}} of {{totalRecords}}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
